import { Btn, IconBell } from '../ui';

export interface UserHeaderProps {
    name: string;
    imageSrc?: string;
    inboxCount?: number;
    onProfileClick?: () => void;
    onInboxClick?: () => void;
    onImageError?: () => void;
}

/** Top bar on the logged-in dashboard: profile bubble, name, and inbox. */
export const UserHeader = ({
    name,
    imageSrc,
    inboxCount = 0,
    onProfileClick,
    onInboxClick,
    onImageError,
}: UserHeaderProps) => {
    const initial = name?.charAt(0)?.toUpperCase() || '?';

    return (
        <div className="hide-from-printer user-header">
            <div className="user-header-search" />
            <div className="user-header-info">
                <div className="user-bubble" onClick={onProfileClick} title="My Profile">
                    {imageSrc ? (
                        <img src={imageSrc} alt="" className="user-bubble-img" onError={onImageError} />
                    ) : (
                        <span className="user-bubble-initial">{initial}</span>
                    )}
                </div>
                <div className="user-header-name">{name}</div>
                {inboxCount > 0 && (
                    <div className="user-header-actions">
                        <Btn
                            variant="icon"
                            buttonSize="sm"
                            buttonClasses="user-header-icon user-header-icon-bell"
                            buttonIcon={<IconBell />}
                            ariaLabel={`Inbox, ${inboxCount} unread message${inboxCount === 1 ? '' : 's'}`}
                            buttonOnClick={onInboxClick}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
